import directives from '../module';
import {HttpSvcFactory} from '../../services/HttpSvc';
import {AuthenticationSvc} from '../../services/AuthenticationSvc';
import {ProjectPageCtrl} from './ProjectPage';
import {Utils} from 'underscore-extensions';

class CommentsCtrl {
    private readonly MaxLength = 500;
    ProjectPageCtrl: ProjectPageCtrl;
    project: anm.Project;
    sending: boolean;
    deleting: boolean;
    updating: boolean;
    Form: ng.INgModelController;

    constructor(private HttpSvc: HttpSvcFactory,
                private AuthenticationSvc: AuthenticationSvc, //used in the template
                private $timeout: ng.ITimeoutService,
                private $filter: ng.IFilterService) {
    }

    $onInit() {
        this.ProjectPageCtrl.projectPromise.then((p: anm.Project) => {
            this.project = p;
            this.project.comments.sort((a, b) => a.created_at - b.created_at);
        });
    }

    update(comment: anm.Comment, newText: string) {
        if (newText.length > this.MaxLength) return;
        this.updating = true;
        this.HttpSvc('comments', comment.comment_id).securePut(newText)
            .finally(() => this.updating = false);
        comment.text = newText;
        comment.edit = false;
    }

    post(post: anm.Comment) {
        if (this.sending) return;
        this.sending = true;
        post.text = this.$filter('stripTags')(post.text);
        this.Form.$setValidity('flood', true);
        this.Form.$setValidity('empty', post.text.length > 0);
        this.Form.$setValidity('maxlength', post.text.length <= this.MaxLength);
        this.$timeout(() => {
            if (this.Form.$valid) {
                this.HttpSvc('comments')
                    .securePost({projectId: this.project.id, text: post.text})
                    .then(r => r.data).then((response: number | ApiError) => {
                        if (Utils.isApiError(response)) {
                            this.Form.$setValidity('flood', response.errorMessage !== 'Too many comments');
                            console.error(`Cannot add comment`, response)
                        } else if (+response !== 0 && !_.isNaN(+response)) {
                            this.project.comments.push({comment_id: response, user: options.user, text: post.text});
                            post.text = '';
                        }
                    })
                    .finally(() => this.sending = false);
            } else {
                this.sending = false;
            }
        });
    }

    delete(id: number) {
        this.deleting = true;
        this.HttpSvc('comments', id).secureDelete().then(() =>
            this.project.comments = this.project.comments.filter(c => c.comment_id !== id)
        ).finally(() => this.deleting = false);

    }

    canDelete(comment: anm.Comment) {
        return options.user.features.Admin ||
            this.myComment(comment) ||
            this.project.owner.username === options.user.username;
    }

    canEdit(comment: anm.Comment) {
        return this.myComment(comment) && this.isMyLast(comment);
    }

    enterEditMode(comment: anm.Comment) {
        this.project.comments.map(c => c.edit = false);
        comment.edit = true;
    }

    private isMyLast(comment: anm.Comment) {
        const last = _.last(this.project.comments.filter(c => !c.deleted && !this.myComment(c)));
        return (last && last.comment_id || 0) < comment.comment_id;
    }

    private myComment(comment: anm.Comment): boolean {
        return comment.user.username === options.user.username;
    }
}
directives.component('comments', {
    controller: CommentsCtrl,
    require: {ProjectPageCtrl: '^projectPage'},
    templateUrl: require('project/comments/comments.html')
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/project/CommentsDirective.ts